import { useDrag, useDrop } from "react-dnd";
import Card from "./Card";
import { useSelector } from "react-redux";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addToast } from "../../../Redux/Slices/toast-slice";
import { fetchApi } from "../../../utlis/axios";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineAddCard } from "react-icons/md";

const DropZone = ({
  column,
  index,
  tickets,
  moveCard,
  moveColumn,
  theme,
  handleCreate,
  ticketsLoading,
  draggingColumn,
  setDraggingColumn,
  handleUpdateColumePosition,
  setTickets,
  columns,
  setColumns,
  handleTicketClick,
  handleEditColumn,
  handleEditTicket,
  setIsTicketLoading,
  setTicketModal
}) => {
  const { userInfo } = useSelector((state) => state?.auth || {});
  const [isOpen, setIsOpen] = useState(false);
  const [isOver, setIsOver] = useState(false);
  const popUpRef = useRef();
  const columnRef = useRef();
  const scrollSpeed = 50; // Pixels per frame
  let scrollInterval = null;
  const dispatach = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popUpRef.current && !popUpRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (scrollInterval) {
        clearInterval(scrollInterval);
      }
    };
  }, []);

  const handleScroll = (clientX, clientY) => {
    const container = document.querySelector('.board-container'); // Add this class to your board container
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const scrollTriggerMargin = 100; // pixels from edge to trigger scroll

    // Clear existing interval
    if (scrollInterval) {
      clearInterval(scrollInterval);
    }

    // Scroll right
    if (clientX > containerRect.right - scrollTriggerMargin) {
      scrollInterval = setInterval(() => {
        container.scrollLeft += scrollSpeed;
      }, 16);
    }
    // Scroll left
    else if (clientX < containerRect.left + scrollTriggerMargin) {
      scrollInterval = setInterval(() => {
        container.scrollLeft -= scrollSpeed;
      }, 16);
    }
  };

  const [{ isDragging }, dragColumn] = useDrag({
    type: "COLUMN",
    item: () => {
      setDraggingColumn(column.id);
      return { id: column.id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      setDraggingColumn(null);
      if (scrollInterval) {
        clearInterval(scrollInterval);
      }
      if (monitor.didDrop()) {
        handleUpdateColumePosition(item.id, item.index);
      }
    },
  });

  const [, dropColumn] = useDrop({
    accept: "COLUMN",
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveColumn(draggedItem.index, index, column.id);
        draggedItem.index = index;
      }
    },
  });

  const [{ isCardOver }, drop] = useDrop({
    accept: "CARD",
    drop: (item) => {
      if (scrollInterval) {
        clearInterval(scrollInterval);
      }
      moveCard(item.id, column.id);
    },
    hover: (item, monitor) => {
      setIsOver(true);
      const clientOffset = monitor.getClientOffset();
      if (clientOffset) {
        handleScroll(clientOffset.x, clientOffset.y);
      }

      // Magnetic effect - if card is near column edges
      const columnRect = columnRef.current?.getBoundingClientRect();
      if (columnRect && clientOffset) {
        const magnetRange = 50; // pixels from edge where magnetic effect starts
        const distanceFromLeft = Math.abs(clientOffset.x - columnRect.left);
        const distanceFromRight = Math.abs(clientOffset.x - columnRect.right);
        
        if (distanceFromLeft < magnetRange || distanceFromRight < magnetRange) {
          // Add stronger visual feedback for magnetic effect
          columnRef.current.style.transform = 'scale(1.02)';
        } else {
          columnRef.current.style.transform = 'scale(1)';
        }
      }
    },
    collect: (monitor) => ({
      isCardOver: monitor.isOver(),
    })
  });

  useEffect(() => {
    if (!isCardOver) {
      setIsOver(false);
      if (columnRef.current) {
        columnRef.current.style.transform = 'scale(1)';
      }
    }
  }, [isCardOver]);

  const handleEdit = () => {
    setIsOpen(false);
    handleEditColumn(column);
  };
  const handleDelete = async () => {
    setIsOpen(false)
    try {
      const res = await fetchApi.delete(`company-board-columns/${column?.id}/`,{
        headers :{
          Authorization: `Bearer ${userInfo.access_token}`
        }
      });
      if(res.status === 204){
        dispatach(addToast({ message: "Column deleted successfully", type: "success" }));
      setColumns(columns.filter((item) => item.id !== column.id));
      }
    } catch (error) {
      dispatach(addToast({ message: error.message, type: "error" }));
    }
  };

  return (
    <>
      <div
        ref={(node) => {
          columnRef.current = node;
          if (userInfo.user.role.name !== "Time Reporter") {
            dropColumn(dragColumn(node));
          }
        }}
        className={`parent-card group shadow-md xs:min-w-[272px] min-w-full h-fit flex flex-col transition-all duration-200 border rounded-[16px] ${
          theme === "dark" ? "border-[#555657] bg-[#1E1E1E] text-white" : "border-[#D8D8D8] bg-[#F5F6FA] text-black"
        } 
        ${isDragging ? "opacity-100" : ""}
        ${isOver ? (theme === "dark" ? "border-blue-500 border-2 shadow-lg" : "border-blue-400 border-2 shadow-lg") : ""}`}
      >
        <div ref={drop} className="h-fit">
          <div className="flex flex-col pt-2 pb-2 pl-2">
            <div className="content py-2">
              <div className="flex w-full justify-between items-center pr-2 bg-transparent rounded-[10px]">
                <div className="flex items-center gap-2">
                  <h2 className="font-semibold text-base capitalize">
                    {column?.title}
                  </h2>
                  <div className={`py-[1px] px-1 rounded-md text-black ${theme === 'dark' ? 'bg-gray-800 text-white':'bg-gray-200 text-black'}` }>
                    {tickets?.length > 0 ? tickets.length : 0}
                  </div>
                </div>
                <div className="relative">
                  <BsThreeDotsVertical className="text-lg cursor-pointer" onClick={()=>setIsOpen(!isOpen)}/>
                  {isOpen && (
                    <div
                      className={`absolute right-0 mt-2 w-32 z-10 rounded-[10px] shadow-lg border overflow-hidden
                                            ${
                                              theme === "dark"
                                                ? "bg-[#212529] border-[#555657]"
                                                : "bg-[#F2F4F7] border-[#9A9F9A]"
                                            }`} ref={popUpRef}
                    >
                      <button
                        className={`w-full text-left px-4 py-2 text-base flex items-center font-medium gap-1 ${
                          theme === "dark"
                            ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all text-white"
                            : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all text-black"
                        }`}
                        onClick={() => handleEdit(column)}
                      >
                      <FaRegEdit className="w-5 h-5"/>
                        Edit
                      </button>
                      <button
                        className={`w-full text-left px-4 py-2 text-base flex gap-1 items-center font-medium text-red-500 ${
                          theme === "dark"
                            ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                            : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                        }`}
                        onClick={() => {
                          handleDelete(column);
                        }}
                      >
                        <RiDeleteBin6Line className="w-5 h-5" />
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            <div className='space-y-3 max-h-[calc(100vh-200px)] overflow-y-auto pr-2'>
              {tickets?.length > 0 ?
                tickets?.map((ticket) => (
                  <Card
                    key={ticket.id}
                    ticket={ticket}
                    ticketLoading={ticketsLoading}
                    setTickets={setTickets}
                    tickets={tickets}
                    handleTicketClick={handleTicketClick}
                    handleEditTicket={handleEditTicket}
                    setIsTicketLoading={setIsTicketLoading}
                    setTicketModal={setTicketModal}
                  />
                )) : 
                ''
              }
            </div>

            <div className="pr-2">
              <button
                className="w-full py-2 bg-transparent rounded-[10px] flex items-center justify-between outline-none text-left font-medium hover:bg-opacity-10 hover:bg-gray-500"
                onClick={() => handleCreate(column.id)}
              >
               + Add new Ticket
               <MdOutlineAddCard className="w-5 h-5"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DropZone;
